import trustpilot from '/public/images/trustpilot.png'
import styles from './Trustpilot.module.scss'
import Image from 'next/image'
import { imageLoader } from '@/loaders/index'

export function Trustpilot({
  numberOfReviews,
  rating
}) {
  return (
    <div className="trustpilot">
      <a
        href={'https://www.trustpilot.com/review/commitaction.com?utm_medium=trustbox&utm_source=MicroTrustScore'}
        target='_blank'
        rel='noreferrer'
      >
        <div className="flex flex-col text-[14px]">
          <div className='flex justify-center md:justify-between mb-[8px] md:mb-[16px]'>
            <span className='mr-[4px]'>{numberOfReviews} Reviews</span> |
            <span className='ml-[4px]'><b>{rating} out</b> of 5</span>
          </div>
          <div className='flex justify-center md:justify-between items-center'>
            <div className='flex'>
              <span className={styles.trustpilot_star}>
                <svg width="12" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.00002 9.15094L9.75474 8.45283L10.9057 12L7.00002 9.15094ZM13.3396 4.56604H8.49059L7.00002 0L5.50946 4.56604H0.6604L4.58493 7.39622L3.09436 11.9623L7.01889 9.13207L9.43399 7.39622L13.3396 4.56604Z" fill="white"></path>
                </svg>
              </span>
              <span className={styles.trustpilot_star}>
                <svg width="12" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.00002 9.15094L9.75474 8.45283L10.9057 12L7.00002 9.15094ZM13.3396 4.56604H8.49059L7.00002 0L5.50946 4.56604H0.6604L4.58493 7.39622L3.09436 11.9623L7.01889 9.13207L9.43399 7.39622L13.3396 4.56604Z" fill="white"></path>
                </svg>
              </span>
              <span className={styles.trustpilot_star}>
                <svg width="12" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.00002 9.15094L9.75474 8.45283L10.9057 12L7.00002 9.15094ZM13.3396 4.56604H8.49059L7.00002 0L5.50946 4.56604H0.6604L4.58493 7.39622L3.09436 11.9623L7.01889 9.13207L9.43399 7.39622L13.3396 4.56604Z" fill="white"></path>
                </svg>
              </span>
              <span className={styles.trustpilot_star}>
                <svg width="12" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.00002 9.15094L9.75474 8.45283L10.9057 12L7.00002 9.15094ZM13.3396 4.56604H8.49059L7.00002 0L5.50946 4.56604H0.6604L4.58493 7.39622L3.09436 11.9623L7.01889 9.13207L9.43399 7.39622L13.3396 4.56604Z" fill="white"></path>
                </svg>
              </span>
              <span className={styles.trustpilot_star}>
                <svg width="12" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.00002 9.15094L9.75474 8.45283L10.9057 12L7.00002 9.15094ZM13.3396 4.56604H8.49059L7.00002 0L5.50946 4.56604H0.6604L4.58493 7.39622L3.09436 11.9623L7.01889 9.13207L9.43399 7.39622L13.3396 4.56604Z" fill="white"></path>
                </svg>
              </span>
            </div>
            <div className='flex ml-[14px] items-center'>
              <div className='scale-[1.3] md:scale-[1] origin-center'>
                <Image
                  src={trustpilot}
                  alt="trustpilot icon"
                  width={12}
                  height={12}
                  loader={imageLoader}
                  priority
                />
              </div>
              <span className='ml-[4px] mt-[3px] font-bold md:font-thin text-[13px] md:text-[11px]'>Trustpilot</span>
            </div>
          </div>
        </div>
      </a>
    </div>
  )
}
